import React, { useMemo } from 'react';
import { Bar } from 'react-chartjs-2';
import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    BarElement,
    Title,
    Tooltip,
    Legend,
} from 'chart.js';

ChartJS.register(
    CategoryScale,
    LinearScale,
    BarElement,
    Title,
    Tooltip,
    Legend
);

function UserAgeDemographics({ users }) {
    const ageDistribution = useMemo(() => {
        const currentYear = new Date().getFullYear();

        const ageRanges = [
            { label: '18-24', min: 18, max: 24 },
            { label: '25-34', min: 25, max: 34 },
            { label: '35-44', min: 35, max: 44 },
            { label: '45-54', min: 45, max: 54 },
            { label: '55-64', min: 55, max: 64 },
            { label: '65+', min: 65, max: 100 },
        ];

        return ageRanges.map((range) => ({
            label: range.label,
            count: users.filter((user) => {
                const userAge = currentYear - new Date(user?.additionalFields?.dob).getFullYear();
                return userAge >= range.min && userAge <= range.max;
            }).length,
        }));
    }, [users]);

    const barChartData = useMemo(() => ({
        labels: ageDistribution.map((item) => item.label),
        datasets: [
            {
                label: 'User Count',
                data: ageDistribution.map((item) => item.count),
                backgroundColor: 'rgba(75, 192, 192, 0.6)',
                borderColor: 'rgba(75, 192, 192, 1)',
                borderWidth: 1,
            },
        ],
    }), [ageDistribution]);

    const barChartOptions = {
        responsive: true,
        maintainAspectRatio: false, // Allows chart height to be controlled by the height prop

        plugins: {
            legend: {
                position: 'top',
            },
            title: {
                display: true,
                text: 'User Age Demographics',
            },
        },
        scales: {
            x: {
                title: {
                    display: true,
                    text: "Age Range",
                },
            },
            y: {
                title: {
                    display: true,
                    text: "Number of Users",
                },
                beginAtZero: true,
                ticks: {
                    stepSize: 10,
                },
            },
        },
    };

    return (
        <div className="space-y-4">
            
                <Bar data={barChartData} options={barChartOptions} height={500}/>

        </div>
    );
}

export default UserAgeDemographics;